import React from "react";
import "../../App.css";
import NavbarComp from "../navbar/navbar";

class Experience extends React.Component {
  render() {
    const accentLinkStyle = { color: "#168f7c", textDecoration: "none" };

    return (
      <div className="container d-flex justify-content-center mt-5">
        <div className="centered-box w-lg-75 w-100">
          <NavbarComp />

          <div className="row">
            <div className="mt-3" id="experience">
              <h5>Experience</h5>
              <hr />

              <ul className="list-group">
                <li className="list-group-item">
                  <div className="row mt-4">
                    <div className="col-lg-3 col-12">
                      <div className="mb-4">
                        <img
                          src="https://interiorlogicgroup.com/wp-content/uploads/2018/12/ILG-Logo-CMYK.png"
                          alt="Interior Logic Group"
                          style={{ height: "60px" }}
                        />
                      </div>

                      <h6>Interior Logic Group, Inc. (A Blackstone Company)</h6>
                      <p className="experience-location">San Diego, CA (Remote)</p>
                      <p>Senior Software Engineer</p>
                      <p className="experience-tenure">Aug 2022 - Present</p>
                    </div>

                    <div className="col-lg-9 col-12">
                      <h6 className="experience-group-title">
                        Platform Architecture &amp; Scale
                      </h6>
                      <ul>
                        <li>
                          Architected and owned the end-to-end backend platform
                          for a 2D/3D/360 visualization product serving 1,000+
                          concurrent users, covering API design, cloud
                          infrastructure, CI/CD, and runtime systems.
                        </li>
                        <li>
                          Led the migration from tightly coupled services to a
                          stateless, event-driven architecture, unlocking
                          horizontal scaling and consistent performance under
                          peak load.
                        </li>
                        <li>
                          Optimized distributed services to handle 500K+ daily
                          requests at consistent sub-second latency.
                        </li>
                        <li>
                          Designed consistency-safe backend workflows across
                          rendering, scheduling, and DevOps services using
                          Redis caching, relational data models, and
                          asynchronous queues, reducing duplicate processing
                          and supporting high-concurrency workloads.
                        </li>
                        <li>
                          Architected stateless, tokenized asset-delivery
                          services with fine-grained access control, reducing
                          misuse risk by 40%.
                        </li>
                        <li>
                          Delivered real-time rendering and streaming pipelines
                          on Spring Boot, Flask, and Node.js, sustaining 99.9%
                          uptime.
                        </li>
                        <li>
                          Integrated Unreal Engine 5 into backend systems,
                          reducing rendering latency by 30% and improving
                          cross-browser consistency.
                        </li>
                      </ul>

                      <h6 className="experience-group-title">
                        Reliability, Automation &amp; Operations
                      </h6>
                      <ul>
                        <li>
                          Implemented a full observability stack (structured
                          logging, metrics, tracing, alerts), reducing MTTR and
                          improving reliability.
                        </li>
                        <li>
                          Automated infrastructure provisioning and scaling
                          on AWS with Boto3 and PowerShell, reducing manual
                          operations effort by 60% and cloud costs by 80%.
                        </li>
                        <li>
                          Cut deployment time from 15 minutes to under 5 by
                          containerizing services and parallelizing CI/CD
                          pipelines.
                        </li>
                        <li>
                          Built an automated floorplan onboarding pipeline
                          integrating YOLO-based detection with asynchronous
                          processing, asset storage, and backend APIs,
                          eliminating manual blueprint tracing and improving
                          spatial-recognition accuracy by 25%.
                        </li>
                        <li>
                          Contributed to an appointment-scheduling service for
                          home buyers and designers, integrating Microsoft Graph
                          for calendar availability, booking, rescheduling,
                          cancellation, and synchronization.
                        </li>
                        <li>
                          Developed Unreal Engine build automation covering
                          source retrieval, packaging, artifact management,
                          environment configuration, and deployment, including
                          Plastic SCM workflows for large binary assets.
                        </li>
                        <li>
                          Improved production resilience with health checks,
                          retry handling, idempotent operations, controlled
                          asynchronous processing, and production-safe
                          deployment practices.
                        </li>
                      </ul>

                      <h6 className="experience-group-title">
                        Product Systems &amp; Collaboration
                      </h6>
                      <ul>
                        <li>
                          Contributed backend asset-processing and delivery
                          capabilities for a Three.js visualization pipeline,
                          connecting application data and 3D assets to
                          browser-based rendering.
                        </li>
                        <li>
                          Led cross-functional collaboration with product
                          managers, designers, and Unreal Engine developers,
                          while bridging platform engineering and infrastructure
                          teams to improve CI/CD, deployment, and observability.
                        </li>
                        <li>
                          Developed internal tools for platform operations,
                          contributed to documentation and training, and
                          supported roadmap demos and codebase quality.
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <hr />

                <li className="list-group-item">
                  <div className="row mt-4">
                    <div className="col-lg-3 col-12">
                      <div className="mb-4">
                        <img
                          src="/images/company/curativly.png"
                          alt="Curativly"
                          style={{ height: "60px" }}
                        />
                      </div>

                      <h6>Curativly (Applied Internet Technology, Inc.)</h6>
                      <p className="experience-location">Chico, CA</p>
                      <p>Senior Software Engineer (Founding Engineer)</p>
                      <p className="experience-tenure">Nov 2020 - Aug 2022</p>
                    </div>

                    <div className="col-lg-9 col-12">
                      <h6 className="experience-group-title">
                        Founding Platform &amp; Backend Systems
                      </h6>
                      <ul>
                        <li>
                          Joined as founding engineer and owned 0→1 backend
                          development for an AR/VR renovation and visualization
                          platform serving 2K+ daily users.
                        </li>
                        <li>
                          Built scalable, event-driven microservices using
                          Express, Node.js, AWS Lambda, Prisma, PostgreSQL,
                          and MongoDB, achieving 99.8% uptime and supporting
                          low-latency user experiences.
                        </li>
                        <li>
                          Engineered Python and MongoDB ingestion pipelines,
                          increasing throughput by 50%.
                        </li>
                        <li>
                          Designed analytics and dashboard backends supporting
                          executive reporting and product insights.
                        </li>
                        <li>
                          Built backend infrastructure for an Unreal Engine
                          rendering fleet, including capacity provisioning,
                          server-health tracking, session assignment, and
                          capacity recovery after sessions ended or failed.
                        </li>
                      </ul>

                      <h6 className="experience-group-title">
                        Real-Time Rendering &amp; Session Orchestration
                      </h6>
                      <ul>
                        <li>
                          Architected a WebSocket-based Unreal Engine Pixel
                          Streaming backend with custom software layers for
                          real-time delivery of server-rendered 3D/AR scenes,
                          owning session orchestration, connection lifecycle,
                          and reconnect handling.
                        </li>
                        <li>
                          Implemented session lifecycle management for
                          allocation, connection establishment, active-session
                          monitoring, timeout handling, cleanup, and failure
                          recovery.
                        </li>
                      </ul>

                      <h6 className="experience-group-title">
                        Reliability, Infrastructure &amp; Leadership
                      </h6>
                      <ul>
                        <li>
                          Built centralized observability across AWS CloudWatch,
                          Elasticsearch, and structured event ingestion to track
                          user sessions, rendering activity, and streaming
                          failures, cutting incident resolution time by 35%.
                        </li>
                        <li>
                          Implemented RBAC, encryption in transit and at rest,
                          and secure API design across critical services.
                        </li>
                        <li>
                          Reduced API latency by 25% through profiling, caching,
                          and query optimization.
                        </li>
                        <li>
                          Cut cloud infrastructure costs by 30% by migrating
                          workloads to lightweight containers and spot-instance
                          infrastructure, extending startup runway without
                          sacrificing reliability.
                        </li>
                        <li>
                          Owned application deployment, rendering-server
                          operations, CI/CD automation, monitoring, and
                          production support across the platform’s AWS
                          infrastructure.
                        </li>
                        <li>
                          Collaborated directly with leadership on dashboards,
                          platform reliability, and long-term technical
                          planning.
                        </li>
                      </ul>

                      <h6 className="experience-group-title">
                        Payments &amp; Order Management
                      </h6>
                      <ul>
                        <li>
                          Architected a payment processing system using the
                          PayPal Commerce Platform, handling order creation,
                          authorization/capture flows, and multi-stage checkout
                          logic with idempotent transaction handling.
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <hr />

                <li className="list-group-item">
                  <div className="row mt-4">
                    <div className="col-lg-3 col-12">
                      <div className="mb-4">
                        <img
                          src="https://studycalifornia.us/wp-content/uploads/2021/02/CSUCHICO-Seal-Color-ISS-Sig-300dpi-6.2018-Steve-Wildhaber-Jr..png"
                          alt="California State University, Chico"
                          style={{ height: "60px" }}
                        />
                      </div>

                      <h6>California State University, Chico</h6>
                      <p className="experience-location">Chico, CA</p>
                      <p>Graduate Research Assistant</p>
                    </div>

                    <div className="col-lg-9 col-12">
                      <ul>
                        <li>
                          Conducted funded research under Dr. Kevin Buffardi for
                          the California Governor's Office of Planning and
                          Research.
                        </li>
                        <li>
                          Published a peer-reviewed paper titled “Is Programming
                          Relevant to CS1 Students’ Interest?”
                        </li>
                        <li>
                          Founding developer for Codewit.us, an inclusive
                          platform for sharing unique perspectives in learning
                          how to code.
                        </li>
                        <li>
                          Acknowledged for development contributions to
                          Codewit.us in the ACM ITiCSE 2022 paper{" "}
                          <a
                            href="https://dl.acm.org/doi/10.1145/3502718.3524778"
                            target="_blank"
                            rel="noreferrer"
                            style={accentLinkStyle}
                          >
                            “Integrating Videos with Programming Practice”
                          </a>
                          .
                        </li>
                        <li>
                          Built an interactive programming portal using Ruby on
                          Rails, PostgreSQL, HTML, CSS, Bootstrap, JavaScript,
                          jQuery, and AJAX.
                        </li>
                        <li>
                          Delivered three successful releases including UAT,
                          regression testing, documentation, and defect
                          tracking.
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Experience;
